// Sugestões padrão exibidas como chips nos diálogos de edição de texto com
// I.A. (TextGenerationForm, TextGenerationFormSection, AiAgentDialog).
// Compartilhada para não divergir (ex.: capitalização) entre os fluxos.
export const DEFAULT_TEXT_SUGGESTIONS = [
  'Melhorar a escrita',
  'Expandir o texto',
  'Resumir o texto',
]
